var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderLogisticsWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93176 4.65799L2.93176 4.56745C2.93176 3.46288 3.82719 2.56745 4.93176 2.56745L10.6588 2.56745C11.0754 2.56745 11.4132 2.22968 11.4132 1.81302V1.81302C11.4132 1.39636 11.751 1.05859 12.1676 1.05859L16.9523 1.05859C18.0568 1.05859 18.9523 1.95402 18.9523 3.05859L18.9523 12.9419C18.9523 14.0465 18.0568 14.9419 16.9523 14.9419L10.942 14.9419",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61649 14.9412L16.5489 14.9412C17.7994 14.9412 18.7432 13.8065 18.5154 12.5769L17.3515 6.29298C17.1759 5.34501 16.349 4.65723 15.385 4.65723L3.45256 4.65723C2.20207 4.65723 1.25826 5.7919 1.48601 7.02148L2.64994 13.3054C2.82552 14.2534 3.6524 14.9412 4.61649 14.9412Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.27273L10.325 8.54545M7 7.27273V11.3833C7 11.5905 7.12777 11.7762 7.32126 11.8502L10.325 13M7 7.27273L10.1548 6.06514C10.2647 6.02307 10.386 6.02112 10.4972 6.05963L14 7.27273M14 7.27273V11.3713C14 11.5844 13.865 11.774 13.6636 11.8438L10.325 13M14 7.27273L10.325 8.54545M10.325 8.54545V13",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4759 11.3255L11.7259 11.9618V10.6891L13.4759 10.0527V11.3255Z",
    fill: "#00A651"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.63574L12.075 7.90847",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderLogisticsWhite);
export default __webpack_public_path__ + "static/media/folder_logistics_white.c0f2a73044f73acde75d7e92f5a204fe.svg";
export { ForwardRef as ReactComponent };